<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.8)" 
size = "medium" color = "#ee0909" 
type = "ball-atom" 
[fullScreen] = "true">
<p style="color: white" > cargando .... </p>
</ngx-spinner>

<div class="container">
    <div class="row">
       
         

</div>
<app-renec (sectorEsById)="onDeesEstandarMarca($event)" *ngIf="!desEstandarMarca" ></app-renec>
<desEstandares [title]="estandarNB"  [codigoEC]="codigoEC"  *ngIf="desEstandarMarca"  (backTo)="estandarMarcaOnBack($event)"></desEstandares>
</div>
